// extracted by mini-css-extract-plugin
module.exports = {"profile":"PersonalInfo_profile__Gfo0B","photo":"PersonalInfo_photo__T8v65","links":"PersonalInfo_links__35kMh","logo":"PersonalInfo_logo__o2rgi"};